import api from './api';

export const login = (data) => api.post('/api/v1/auth/login', data);
export const register = (data) => api.post('/api/v1/auth/register', data);
export const requestPasswordReset = (email) => api.post('/api/v1/auth/request-reset', { email });
export const resetPassword = (data) => api.post('/api/v1/auth/reset-password', data);
export const verifyAccount = (data) => api.post('/api/v1/auth/verify-account', data);
export const resendVerificationCode = (email) => api.post('/api/v1/auth/resend-verification', { email });
export const getMe = () => api.get('/api/v1/auth/me');
export const logoutApi = () => api.post('/api/v1/auth/logout');
